import { DataSource, Layout, SearchPanel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommSendLoadHistoryList extends Layout {
    searchpanel1: SearchPanel;
    sourceMcZmitHistory: DataSource;
    switchDriverDepartReceived: Switch;
    tableSendLoadHistory: Table;
    textboxAutoArriveSearch: Textbox;
    textboxAutoDepartSearch: Textbox;
    textboxLocalIdSearch: Textbox;
    textboxMcControlIdSearch: Textbox;
    textboxMcUnitNoSearch: Textbox;
    textboxMovementIdSearch: Textbox;
    textboxRecordTypeSearch: Textbox;
    textboxRemoteIdSearch: Textbox;
}
